import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import TextField from '@mui/material/TextField';

import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));



/* Liste des réponses possibles */
const causeLabel = "Cause du litige";
const causes = [
    '"Hors garantie constructeur" alors que "Garantie commerciale" annoncée au client, le client refuse de payer',
    'Préjudice suite à la période d\'indisponibilité',
    'Préjudice sur produits montés à remplacer / réparer',
    'Délai plus important qu\'annoncé initialement',
    'Réparation multiple (l\'article a été réparé plusieurs fois et ne marche toujours pas correctement ...)',
];

const demandeLabel = "Demande du client";
const demandes = [
    'Remboursement du produit initial',
    'Dédommagement sur préjudice',
    'Autre',
];



function DeclarerLitigeDialogContent({ onChange, action }) {


    const classes = useStyles();

    const [cause, setCause] = useState('');
    const [demande, setDemande] = useState('');
    const [montant, setMontant] = useState('');
    const [autre, setAutre] = useState('');

    
    useEffect(() => {
        onChange(null);
    }, [onChange]);


    useEffect(() => {


        const getActionData = () => {

            if (cause === '') {
                return null;
            }
            if (demande === '') {
                return null;
            }
            if (demande === 1 && montant === '') {
                return null;
            }
            if (demande === 2 && autre === '') {
                return null;
            }

            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: causeLabel,
                        position: 0,
                        valeurString: causes[cause],
                        valeurInteger: cause
                    },
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: demandeLabel,
                        position: 1,
                        valeurString: demandes[demande],
                        valeurInteger: demande
                    }]
            };

            if (demande === 1) {
                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.Flottant,
                        libelle: "Montant demandé",
                        position: actionData.details.length,
                        valeurFloat: montant
                    }
                );
            }

            if (demande === 2) {
                actionData.details.push(
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.Texte,
                        libelle: "Demande",
                        position: actionData.details.length,
                        valeurString: autre
                    }
                );
            }


            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, cause, demande, montant, autre]);




    return (
        <DialogContent>


            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{causeLabel}</FormLabel>
                <RadioGroup
                    value={cause.toString()}
                    onChange={e => setCause(parseInt(e.target.value, 10))}
                >
                    {causes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{demandeLabel}</FormLabel>
                <RadioGroup
                    value={demande.toString()}
                    onChange={e => setDemande(parseInt(e.target.value, 10))}
                >
                    {demandes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>

            {demande === 1 && (
                <TextField
                    className={classes.formControl}
                    value={montant}
                    onChange={e => setMontant(e.target.value)}
                    variant={"filled"}
                    label={"Montant demandé"}
                    type="number"
                    inputProps={{ min: 0 }}
                    required
                    autoFocus
                />                
            )}

            {demande === 2 && (

                <TextField
                    className={classes.formControl}
                    value={autre}
                    onChange={e => setAutre(e.target.value)}
                    variant={"filled"}
                    label={"Demande"}
                    multiline
                    required
                    autoFocus
                />
                
            )}


        </DialogContent>
    );

}


export default DeclarerLitigeDialogContent;